import React,{ Component } from 'react';

import {
  Button
} from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validateRatableEngagement } from '../../../shared/validators';

class CampaignRatableForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      video:null,
      isShowingPopover:false
    };
  }

  componentDidMount(){
    if(this.props.activeEngagementVideoURL && this.props.activeEngagementVideoFileName){
      this.setState({video:{
        id:this.props.activeEngagementVideoId,
        fileName:this.props.activeEngagementVideoFileName,
        original:this.props.activeEngagementVideoURL
      }});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const video = this.state.video;

    data.tags = (data.firstTags || []);

    if(video){
      data.videoId = video.id;
      data.videoURL = video.original;
      data.videoFileName = video.fileName;
    }

    const validationMessages = validateRatableEngagement(data);

    delete data.firstTags;

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target={`VideoInput_${this.props.activeEngagementId}`}
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Video Activity'
        >
          <p>
            Consumers watch a video and give thumbs up or down feedback.  We recommend videos between 15 and 30 seconds.  We also recommend one video per campaign.
            <br /><br />
            Suggestions:<br />
            Introduce your brand or product<br />
            Communicate your values<br />
            Let consumers see behind the scenes
          </p>
        </TutorialPopover>
        <HiddenInput name='id' value={this.props.activeEngagementId} />
        <DroppableFileInput
          id={`VideoInput_${this.props.activeEngagementId}`}
          label='Video'
          fileType='video'
          name='video'
          text='Upload video'
          warning={this.state.validationMessages['videoURL']}
          onChange={(video) => this.setState({video:video})}
          existingFileName={this.props.activeEngagementVideoFileName}
          existingFileURL={this.props.activeEngagementVideoURL}
          tooltip={(
            <span>Use a short mp4 or mov file with an aspect ratio of 16x9.<br />Maximum file size of 10MB. <br />This should be about 15 seconds at 720p.</span>
          )}
        />
        <TextInput
          label='Introduce your video'
          name='text'
          multiline
          defaultValue={this.props.activeEngagementText}
          placeholder='Check out our latest offering'
          warning={this.state.validationMessages['text']}
          maxLength={50}
        />
        <DCMTagInput 
          type='first' 
          name='firstTags'
          defaultValue={this.props.activeEngagementFirstTags}
          warning={this.state.validationMessages['firstTags']}
        />
        <br />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignRatableForm.defaultProps = {
  isShowingTutorial:true
}

export default CampaignRatableForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignRatableForm.js